<template>
  <div>
    <page-header>
      <template v-slot:title>
        <div>
          {{$route.meta.tab_name}}  {{$route.meta.icon}} 
        </div>
      </template>
    </page-header>
    <div class="mb-4">
      <form-event-info ref="form_event_info" is_component_create_event ></form-event-info>
    </div>
    <dialog-loading v-if="loading" loadingText='Salvando'></dialog-loading>
  </div>
</template>

<script>
  import validations from "@/mixins/validations";
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'RegisterEvent',
    mixins: [ validations ],
    components: {
      FormEventInfo: () => import ('./register_forms/FormEventInfo.vue'),
      // FormEventClient: () => import ('./register_forms/FormEventClient.vue'),
      // FormEventActivities: () => import ('./register_forms/FormEventActivities.vue'),
      // FormEventDetails: () => import ('./register_forms/FormEventDetails.vue'),
      // FormEventFinancial: () => import ('./register_forms/FormEventFinancial.vue'),
      // EventSummary: () => import ('./register_forms/EventSummary.vue'),
    },
    data() {
      return {
        loading: false,
        valid: true,
      }
    },
    methods: {
      // prepareEvent(){
      //   //const regex = /\W/g
      //   // let { parcels } = this.event_info
      //   // // let {phone, document, corporate_person_document, client_address} = client
      //   // // zip = zip.replaceAll(regex, '')
      //   // // phone = phone.replaceAll(regex, '')
      //   // // document = document.replaceAll(regex, '')
      //   // // corporate_person_document = corporate_person_document.replaceAll(regex, '')
      //   // let event = {
      //   //   ...this.event_info,
      //   //   // zip,
      //   //   // client: {
      //   //   //   ...this.event_info.client,
      //   //   //   phone,
      //   //   //   document,
      //   //   //   corporate_person_document,
      //   //   //   client_address: {
      //   //   //     ...client_address,
      //   //   //     zip: client_address.zip.replaceAll(regex, '')
      //   //   //   }
      //   //   // },
      //   //   movements_attributes: [...parcels.map((p, idx, arr)=> {
      //   //     let {company_id, ...parcel} = p
      //   //     company_id = this.activeCompanyId
      //   //     return {...parcel, company_id}
      //   //   })]
      //     // movements_attributes: [...parcels]
      //   // }
      // },

      // ...mapActions({
      //   createEvent: 'Event/create',
      //   commitEvent: 'Event/commitEvent',
      //   commitStepper: 'Event/commitStepper'
      // }),
    },
    computed: {
      can_save(){
        // this.$refs.form_event_info.validateForm()
        return true
      },
      ...mapState({
        base_event: state => state.Event.base_event,
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },
    watch: {
    },
  }
</script>

<style lang="scss">
</style>